import { MainContentLayout } from 'shared/ui/layout';

import { EditCarModel } from 'features/car/edit-car-model';

export function EditCarModelPage() {
  return <MainContentLayout element={<EditCarModel />} />;
}
